"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("./errors");
class CmdAssembler {
    constructor(args) {
        this.namedArgs = {};
        this.namedShortArgs = {};
        for (const [key, value] of Object.entries(args.namedArgs)) {
            const v = Object.assign({}, value, { name: key });
            this.namedArgs[key] = v;
            if (value.shortName !== undefined) {
                if (this.namedShortArgs[value.shortName]) {
                    throw new Error(`Duplicated shortName: ${value.shortName}`);
                }
                this.namedShortArgs[value.shortName] = v;
            }
        }
    }
    process(parsedCmd) {
        const namedArgs = {};
        const positionalArgs = new Array();
        const errors = new errors_1.ErrorsImpl();
        function setArg(arg, values) {
            if (namedArgs[arg.name]) {
                errors.addError({
                    kind: "DuplicateArgument",
                    argName: arg.name,
                    message: `A value for argument "${arg.name}" has already been specified.`,
                });
                return;
            }
            namedArgs[arg.name] = {
                kind: "NamedArg",
                name: arg.name,
                values,
            };
        }
        const queue = parsedCmd.parts.slice(0);
        while (true) {
            const part = queue.shift();
            if (!part) {
                break;
            }
            if (part.kind === "NamedValue") {
                const argInfo = (part.isShort
                    ? this.namedShortArgs
                    : this.namedArgs)[part.name];
                if (!argInfo) {
                    errors.addError({
                        kind: "UnknownArgument",
                        argName: part.name,
                        message: `Did not expect an argument with name "${part.name}".`,
                    });
                    continue;
                }
                switch (argInfo.kind) {
                    case "MultiValue":
                        const values = new Array();
                        while (queue[0] && queue[0].kind === "Value") {
                            values.push(queue[0].value);
                            queue.shift();
                        }
                        setArg(argInfo, values);
                        break;
                    case "SingleValue":
                        let value = part.value;
                        if (value === undefined) {
                            if (queue[0] && queue[0].kind === "Value") {
                                value = queue[0].value;
                                queue.shift();
                            }
                        }
                        if (!value) {
                            errors.addError({
                                kind: "MissingValue",
                                argName: part.name,
                                message: `A value is missing for argument "${part.name}".`,
                            });
                            continue;
                        }
                        setArg(argInfo, [value]);
                        break;
                    case "NoValue":
                        setArg(argInfo, []);
                        break;
                    default:
                        const x = argInfo.kind;
                }
            }
            else {
                positionalArgs.push({ kind: "Value", value: part.value });
            }
        }
        return {
            namedArgs,
            positionalArgs,
            errors,
        };
    }
}
exports.CmdAssembler = CmdAssembler;
//# sourceMappingURL=assembler.js.map